import { tokenProvider } from './token-provider.js';
import { Router } from '@vaadin/router';

export class AuthMonitor {
  constructor() {
    this.tokenProvider = tokenProvider;
    this.checkInterval = null;
    this.isMonitoring = false;
  }
  
  startMonitoring() {
    if (this.isMonitoring) return;
    
    // Check every minute
    this.checkInterval = setInterval(() => this.checkSession(), 60000);
    
    // Also check on page visibility change
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.checkSession();
      }
    });
    
    this.isMonitoring = true;
    console.log('Session monitoring started');
  }
  
  async checkSession() {
    const token = this.tokenProvider.getToken();
    if (!token) {
      console.log('No active session to monitor');
      this.stopMonitoring();
      return;
    }
    
    // If token is expired, try to refresh it
    if (this.tokenProvider.isTokenExpired()) {
      console.log('Session expired, attempting refresh');
      const refreshed = await this.tokenProvider.refreshToken();
      
      if (!refreshed) {
        console.log('Token refresh failed, redirecting to login');
        this.tokenProvider.clear();
        Router.go('/login');
      }
      return;
    }
    
    // If session is about to expire in the next 5 minutes, refresh it
    if (this.tokenProvider.isTokenExpiringSoon(5)) {
      console.log('Session expiring soon, refreshing token');
      await this.tokenProvider.refreshToken();
    }
  }
  
  stopMonitoring() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
    document.removeEventListener('visibilitychange', this.checkSession);
    this.isMonitoring = false;
    console.log('Session monitoring stopped');
  }
}

// Create a singleton instance
export const authMonitor = new AuthMonitor(); 